<template>
  <div id="footer-socials">
    <SocialLinks />
  </div>
</template>

<script setup>
import SocialLinks from '@/components/SocialLinks.vue'
</script>

<style lang="scss" scoped>
#footer-socials {
  display: flex;
  gap: $spacing-6;

  @include mobile {
    width: 100%;
    justify-content: space-between;
  }

  &::v-deep(a) {
    width: 54px;
    height: 54px;
    border: 1px solid $brand-primary;
    border-radius: 50%;
    padding: $spacing-4;
    color: $brand-primary;
  }
}
</style>
